import { Box, Container, Paper, Stack, useTheme } from "@mui/material";
import { CartButton } from "./cart-button.js";
import { LocalizationContext } from "../localization/index.js";
import { Logo } from "../logo/index.js";
import { NavItem } from "./desktop-item.js";
import { useTranslation } from "next-i18next";
import { useWindowScrollPosition } from "rooks";
import Link from "next/link";
import React from "react";
export const DesktopStickyHeader = ({ items }) => {
    const { mode } = React.useContext(LocalizationContext);
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const { scrollY } = useWindowScrollPosition();
    const show = scrollY > 1440;
    return (React.createElement(Paper, { id: "sticky-header", elevation: 5, sx: {
            backgroundColor: "white",
            left: 0,
            opacity: show ? 1 : 0,
            position: "fixed",
            top: 0,
            transform: `translateY(${show ? "0" : "-100%"})`,
            transition: theme.transitions.create(["transform", "opacity"]),
            width: "100%",
            zIndex: show ? 60 : -10,
        } },
        React.createElement(Container, { maxWidth: false, sx: { maxWidth: theme.breakpoints.values.xl } },
            React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", sx: { px: 0, py: 0 } },
                React.createElement(Box, { sx: { width: { md: "270px", xl: "320px" }, pt: { md: 0.5, xl: 0.5 }, height: "auto" } },
                    React.createElement(Link, { "aria-label": t("front-page", "Startseite"), href: "/", title: t("seo-site-title") },
                        React.createElement(Logo, { fill: theme.palette.text.primary, variant: "horizontal", title: t("seo-site-title") }))),
                React.createElement(Box, null,
                    React.createElement(Stack, { spacing: 5, direction: "row" },
                        items.map((item) => (React.createElement(NavItem, { key: item.label, indicatorColor: theme.palette.text.primary, item: item }))),
                        mode === "store" && React.createElement(CartButton, { color: theme.palette.text.primary })))))));
};
//# sourceMappingURL=desktop-sticky.js.map